<template>
  <div class="fullscrean">
    <div>
      <img src="../assets/logo-lecard.png" class="img-fluid" alt="Logo Lecard" style="width: 96px">
      <div class="mt-4">
        <h5 class="mb-2 font-weight-bold">Atualize seu plano</h5>
        <p class="mb-4" style="max-width: 500px">
          Seu atendimento nunca será o mesmo com o <b>Bot do LeCard</b>, a nossa solução irá
          coletar os pedidos, informar todo o processo de preparo além de responder as mensagens dos seus cliente.
        </p>
        <div>
          <a href="https://wa.me/5535997409802" target="_blank" class="btn btn-primary">Contrate agora! <i class="fas fa-rocket"></i></a>
        </div>
        <div class="mt-4">
          <a href="javascript:" class="btn text-dark" @click="confirmLogout()">Sair do sistema</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import TopBar from "@/components/commons/TopBar";
  export default {
    name: 'Upgrade',
    components: {TopBar},

    methods: {
      confirmLogout() {
        this.logout();
      }
    }
  }
</script>

<style scoped>
</style>
